export const constants = {
    thresholdWidth: 600
}
